import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from 'src/layout'

/* Router Modules */


/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
    {
        path: '/redirect',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/redirect/:path(.*)',
                component: () => import('src/views/redirect/index')
            }
        ]
    },
    {
        path: '/login',
        component: () => import('src/views/login/index'),
        hidden: true
    },
    {
        path: '/auth-redirect',
        component: () => import('src/views/login/auth-redirect'),
        hidden: true
    },
    {
        path: '/404',
        component: () => import('src/views/error-page/404'),
        hidden: true
    },
    {
        path: '/401',
        component: () => import('src/views/error-page/401'),
        hidden: true
    },
    {
        path: '/',
        component: Layout,
        redirect: '/home',
        children: [
            {
                path: 'home',
                component: () => import('src/views/home/index'),
                name: 'Home',
                meta: { title: 'home', icon: 'home', affix: true }
            }
        ]
    },
    {
        path: '/profile',
        component: Layout,
        redirect: '/profile/index',
        hidden: true,
        children: [
            {
                path: 'index',
                component: () => import('src/views/profile/index'),
                name: 'Profile',
                meta: { title: 'profile', icon: 'user', noCache: true }
            }
        ]
    }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
    {
        path: '/system-manage',
        component: Layout,
        redirect: '/system-manage/user-list',
        alwaysShow: true, // will always show the root menu
        name: 'SystemManage',
        meta: {
            title: 'systemManage',
            icon: 'system-manage'
        },
        children: [
            {
                path: 'user-list',
                component: () => import('src/views/system-manage/user-list'),
                name: 'UserList',
                meta: { title: 'userList', icon: 'user-list' }
            },
            {
                path: 'role-list',
                component: () => import('src/views/system-manage/role-list'),
                name: 'RoleList',
                meta: { title: 'roleList', icon: 'role-list' }
            },
            {
                path: 'schedule',
                component: () => import('src/views/job/schedule'),
                name: 'Schedule',
                meta: { title: 'schedule', icon: 'schedule' }
            }
        ]
    },
    {
        path: '/analyse-manage',
        component: Layout,
        redirect: '/analyse-manage/fl',
        alwaysShow: true, // will always show the root menu
        name: 'AnalyseManage',
        meta: {
            title: '粉率报表',
            icon: 'system-manage'
        },
        children: [
            {
                path: 'fl',
                component: () => import('src/views/analyse-manage/fl'),
                name: 'UserList',
                meta: { title: '粉率', icon: 'user-list' }
            },
            {
                path: 'dh',
                component: () => import('src/views/analyse-manage/dh'),
                name: 'UserList',
                meta: { title: '电耗', icon: 'user-list' }
            }
        ]
    },

    {
        path: '/formula-manage',
        component: Layout,
        redirect: '/formula-manage/wheat-formula',
        alwaysShow: true, // will always show the root menu
        name: 'FormulaManage',
        meta: {
            title: 'formulaManage',
            icon: 'formula-manage'
        },
        children: [
            {
                path: 'material-manage',
                component: () => import('src/views/formula-manage/material-manage'),
                name: 'MaterialManage',
                meta: { title: 'materialManage', icon: 'production' }
            },
            {
                path: 'wheat-formula',
                component: () => import('src/views/formula-manage/wheat-formula'),
                name: 'WheatFormula',
                meta: { title: 'wheatFormula', icon: 'production' }
            },
            {
                path: 'flour-formula',
                component: () => import('src/views/formula-manage/flour-formula'),
                name: 'FlourFormula',
                meta: { title: 'flourFormula', icon: 'production' }
            }
        ]
    },
    {
        path: '/production-schedule',
        component: Layout,
        redirect: '/production-schedule/wheat-formula-schedule',
        alwaysShow: true, // will always show the root menu
        name: 'ProductionSchedule',
        meta: {
            title: 'productionSchedule',
            icon: 'formula-manage'
        },
        children: [
            {
                path: 'wheat-formula-prod',
                component: () => import('src/views/production-schedule/wheat-formula-prod'),
                name: 'WheatFormulaProd',
                meta: { title: 'wheatFormula', icon: 'production' }
            },
            {
                path: 'wheat-formula-schedule',
                component: () => import('src/views/production-schedule/wheat-formula-schedule'),
                name: 'WheatFormulaSchedule',
                meta: { title: 'wheatFormulaSchedule', icon: 'production' }
            },
            {
                path: 'flour-formula-prod',
                component: () => import('src/views/production-schedule/flour-formula-prod'),
                name: 'FlourFormulaProd',
                meta: { title: 'flourFormula', icon: 'production' }
            },
            {
                path: 'flour-formula-schedule',
                component: () => import('src/views/production-schedule/flour-formula-schedule'),
                name: 'FlourFormulaSchedule',
                meta: { title: 'flourFormulaSchedule', icon: 'production' }
            },
            {
                path: 'wheat-pour-schedule',
                component: () => import('src/views/production-schedule/wheat-pour-schedule'),
                name: 'WheatPourSchedule',
                meta: { title: 'wheatPourSchedule', icon: 'production' }
            },
            {
                path: 'flour-pour-schedule',
                component: () => import('src/views/production-schedule/flour-pour-schedule'),
                name: 'FlourPourSchedule',
                meta: { title: 'flourPourSchedule', icon: 'production' }
            }
        ]
    },
    {
        path: '/chart-analysis',
        component: Layout,
        redirect: '/chart-analysis/farinogram',
        alwaysShow: true, // will always show the root menu
        name: 'ChartAnalysis',
        meta: {
            title: 'chartAnalysis',
            icon: 'system-manage'
        },
        children: [
            {
                path: 'farinogram',
                component: () => import('src/views/chart-analysis/farinogram'),
                name: 'Farinogram',
                meta: { title: 'farinogram', icon: 'farinogram' }
            },
            {
                path: 'real-flow',
                component: () => import('src/views/chart-analysis/real-flow'),
                name: 'RealFlow',
                meta: { title: 'realFlow', icon: 'real-flow' }
            },
            {
                path: 'history-flow',
                component: () => import('src/views/chart-analysis/history-flow'),
                name: 'HistoryFlow',
                meta: { title: 'historyFlow', icon: 'history-flow' }
            }
        ]
    },
    {
        path: '/wx-manage',
        component: Layout,
        redirect: '/wx-manage/wx-account',
        alwaysShow: true, // will always show the root menu
        name: 'WxManage',
        meta: {
            title: 'wxManage',
            icon: 'wx-manage'
        },
        children: [
            {
                path: 'wx-account',
                component: () => import('src/views/wx-manage/wx-account'),
                name: 'WxAccount',
                meta: { title: 'wxAccount', icon: 'wx-account' }
            },
            {
                path: 'wx-menu',
                component: () => import('src/views/wx-manage/wx-menu'),
                name: 'WxMenu',
                meta: { title: 'wxMenu', icon: 'wx-menu' }
            },
            {
                path: 'wx-user',
                component: () => import('src/views/wx-manage/wx-user'),
                name: 'WxUser',
                meta: { title: 'wxUser', icon: 'wx-user' }
            },
            {
                path: 'msg-template',
                component: () => import('src/views/wx-manage/msg-template'),
                name: 'MsgTemplate',
                meta: { title: 'msgTemplate', icon: 'msg-template' }
            },
            {
                path: 'wx-qrcode',
                component: () => import('src/views/wx-manage/wx-qrcode'),
                name: 'WxQrCode',
                meta: { title: 'wxQrCode', icon: 'wx-qrcode' }
            },
            {
                path: 'msg-reply-rule',
                component: () => import('src/views/wx-manage/msg-reply-rule'),
                name: 'MsgReplyRule',
                meta: { title: 'msgReplyRule', icon: 'msg-reply-rule' }
            },
            {
                path: 'wx-msg',
                component: () => import('src/views/wx-manage/wx-msg'),
                name: 'WxMsg',
                meta: { title: 'wxMsg', icon: 'wx-msg' }
            },
            {
                path: 'wx-assets',
                component: () => import('src/views/wx-manage/wx-assets'),
                name: 'WxAssets',
                meta: { title: 'wxAssets', icon: 'wx-assets' }
            },
            {
                path: 'swiper',
                component: () => import('src/views/wx-manage/swiper'),
                name: 'Swiper',
                meta: { title: 'swiper', icon: 'swiper' }
            }
        ]
    },
    // 404 page must be placed at the end !!!
    { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router
